import type { TimelineEvent } from "../hooks/useRecording";

export function getEventColor(eventType: string, payload: Record<string, unknown>): string {
  if (eventType === "input.user") return "#3b82f6";
  if (eventType === "agent.tool_call") return "#22c55e";
  if (eventType === "agent.tool_result") return "#22c55e";
  if (eventType === "test.step") return payload.status === "failed" ? "#ef4444" : "#f97316";
  if (eventType === "app.ready") return "#06b6d4";
  if (eventType === "screenshot") return "#a855f7";
  return "#6b7280";
}

function formatTime(t_ms: number): string {
  const s = Math.floor(t_ms / 1000);
  const m = Math.floor(s / 60);
  const rem = s % 60;
  return `${m}:${rem.toString().padStart(2, "0")}`;
}

interface Props {
  event: TimelineEvent;
  onClick: () => void;
}

export default function TimelineEventRow({ event, onClick }: Props) {
  const color = getEventColor(event.type, event.payload);
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "8px 14px",
        cursor: "pointer",
        borderBottom: "1px solid #111827",
        transition: "background 0.1s",
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLDivElement).style.background = "#1f2937";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLDivElement).style.background = "transparent";
      }}
    >
      <span
        style={{
          fontSize: 11,
          color: "#6b7280",
          fontFamily: "monospace",
          flexShrink: 0,
          width: 40,
        }}
      >
        {formatTime(event.t_ms)}
      </span>
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: color,
          flexShrink: 0,
        }}
      />
      <span
        style={{
          fontSize: 12,
          color,
          fontWeight: 600,
          flexShrink: 0,
          maxWidth: 140,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {event.type}
      </span>
      {event.payload.name !== undefined && event.payload.name !== null && (
        <span
          style={{
            fontSize: 11,
            color: "#9ca3af",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {String(event.payload.name)}
        </span>
      )}
    </div>
  );
}
